import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@app/guards/auth.guard';
import { OnlyCustomersGuard } from '@app/guards/only-customers.guard';

import * as fromComponents from './components';
import { ReportingComponent } from './reporting.component';

const routes: Routes = [
  {
    path: 'reports',
    canActivate: [AuthGuard, OnlyCustomersGuard],
    component: ReportingComponent,
    children: [
      { path: 'dashboard', component: fromComponents.ReportingDashboardComponent },
      { path: 'transactions', component: fromComponents.ReportingTransactionsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportingRoutingModule {}
